import { Outlet } from 'react-router-dom'

const PayrollCyclesOverviewpage = () => {
  return <Outlet />
}

export default PayrollCyclesOverviewpage
